angular.module('zc.projects')

.directive 'zcHeatmapTable', ->
  restrict: 'E'
  scope:
    pages: '='
  templateUrl: '/templates/projects.heatmap/views/directives/heatmap_table.html'



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/heatmap_table.directive.coffee